import styled from "styled-components";
import { LARGE_SCREEN } from "@streeteasy/design-system/constants/screenSizes";
import { WHITE } from "design-system/colors";

import SEModal from "src/shared/components/SEModal";

export const ContentWrapper = styled(SEModal)`
  background-color: white;
  box-shadow: -6px 0px 6px 0 rgba(0, 0, 0, 0.2);
  height: 100%;
  transition: right 0.5s;
  width: 480px;
  z-index: 1001;

  &.ReactModal__Content--after-open {
    right: 0 !important;
  }

  &.ReactModal__Content--before-close {
    right: -490px !important;
  }

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    width: 100%;
  }
`;

export const ModalContent = styled.div`
  background-color: ${WHITE};
  display: flex;
  height: 100%;
  overflow: hidden;
  width: 100%;

  @media (min-width: ${LARGE_SCREEN}px) {
    height: 100vh;
  }
`;

ContentWrapper.displayName = "ContentWrapper";
